import React from 'react';

export function SolutionIcon() {
	return (
		<svg
			width="40"
			height="40"
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_879_8568)">
				<path
					d="M18.092 29.098C17.14 29.098 16.766 28.792 16.766 27.772C16.766 24.61 18.228 23.284 19.792 22.298C21.56 21.21 23.43 20.53 23.43 18.116C23.43 16.586 22.376 15.498 20.166 15.498C17.888 15.498 16.868 16.484 16.052 18.32C15.61 19.34 15.236 19.544 14.284 19.204L11.972 18.354C11.02 18.014 10.748 17.538 11.122 16.586C12.448 13.186 15.202 10.874 20.234 10.874C25.708 10.874 28.87 13.968 28.87 17.912C28.87 23.08 25.198 24.27 23.056 25.596C22.104 26.174 21.424 26.82 21.424 27.772C21.424 28.792 21.084 29.098 20.098 29.098H18.092ZM18.806 36.272C16.868 36.272 16.222 35.66 16.222 33.722V33.11C16.222 31.172 16.868 30.56 18.806 30.56H19.486C21.424 30.56 22.07 31.172 22.07 33.11V33.722C22.07 35.66 21.424 36.272 19.486 36.272H18.806Z"
					fill="#8252DD"
				/>
				<path
					d="M20.8768 11.066C20.9975 9.50598 19.8308 8.14344 18.2708 8.02268C16.7107 7.90193 15.3482 9.06869 15.2274 10.6287C15.1067 12.1887 16.2734 13.5513 17.8335 13.672C19.3935 13.7928 20.756 12.626 20.8768 11.066Z"
					fill="white"
				/>
				<path
					d="M24.2447 11.91C25.1677 10.6465 24.8916 8.87401 23.6281 7.95108C22.3646 7.02815 20.5921 7.30425 19.6692 8.56777C18.7462 9.83128 19.0223 11.6037 20.2858 12.5267C21.5494 13.4496 23.3218 13.1735 24.2447 11.91Z"
					fill="white"
				/>
				<path
					d="M23.7515 5.88698L20.7077 5.74191C20.4096 5.7277 20.1565 5.95785 20.1422 6.25596L20.1145 6.83715C20.1003 7.13526 20.3305 7.38845 20.6286 7.40266L23.6724 7.54773C23.9705 7.56193 24.2237 7.33179 24.2379 7.03368L24.2656 6.45248C24.2798 6.15437 24.0496 5.90119 23.7515 5.88698Z"
					fill="#000A23"
				/>
				<path
					d="M18.2142 4.23984L15.4833 5.59182C15.2158 5.72423 15.1064 6.0484 15.2388 6.31586L15.4969 6.83731C15.6293 7.10478 15.9535 7.21426 16.221 7.08185L18.9519 5.72987C19.2194 5.59746 19.3288 5.27329 19.1964 5.00583L18.9383 4.48438C18.8059 4.21691 18.4817 4.10743 18.2142 4.23984Z"
					fill="#000A23"
				/>
				<path
					d="M20.0224 11.5572C20.0281 10.6701 19.3136 9.9464 18.4265 9.94073C17.5394 9.93506 16.8157 10.6496 16.8101 11.5366C16.8044 12.4237 17.5189 13.1474 18.406 13.1531C19.2931 13.1588 20.0168 12.4442 20.0224 11.5572Z"
					fill="#000A23"
				/>
				<path
					d="M22.9806 11.9378C23.495 11.2336 23.3411 10.2457 22.6369 9.73131C21.9327 9.21692 20.9448 9.37081 20.4304 10.075C19.916 10.7792 20.0699 11.7671 20.7741 12.2815C21.4783 12.7959 22.4662 12.642 22.9806 11.9378Z"
					fill="#000A23"
				/>
				<path
					d="M20.7105 15.1161C21.221 15.0366 21.6116 14.6604 21.7342 14.1905C21.8059 13.9155 21.5318 13.7155 21.251 13.7592L19.7829 13.9879C19.5021 14.0317 19.3018 14.3056 19.4537 14.5457C19.7135 14.9561 20.2 15.1956 20.7105 15.1161Z"
					fill="#27292C"
				/>
			</g>
			<defs>
				<clipPath id="clip0_879_8568">
					<rect width="40" height="40" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
